import React from 'react';
import Source from './containers/Source'

export default [
    {
        path: '/source',
        exact: true,
        component: () => <Source />
    }
];